export const RECEIVE_ARTICLE = "RECEIVE_ARTICLE"

export const receiveArticle = articles => {
    return {
        type: RECEIVE_ARTICLE,
        articles
    }
}